export const TOGGLE_SIZE_MODIFIERS = {
  sm: 'd-toggle--small',
  md: '',
};

export const TOGGLE_CHECKED_VALUES = [false, true, 'mixed'];

export default {
  TOGGLE_SIZE_MODIFIERS,
  TOGGLE_CHECKED_VALUES,
};
